import React, { memo } from "react";

import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  VStack,
} from "@chakra-ui/react";
import { LockIcon } from "modules/icons";
import ModalTitle from "./modal-title";
import { useOverlay } from "modules/providers/overlay-provider";

const LockConversationGeneralInfoModal = () => {
  const { closeModal } = useOverlay();

  return (
    <Modal isOpen onClose={closeModal} size="sm" isCentered>
      <ModalOverlay />
      <ModalContent borderRadius={16}>
        <ModalBody p={6}>
          <VStack textAlign="center" spacing={4}>
            <ModalTitle
              text="Private Threads?"
              icon={<LockIcon boxSize={16} />}
            />
            <Text fontSize={13}>
              Set threads to “Private” to prevent anyone in the thread from
              adding users and groups to it. <br />
              Anyone in the thread can remove the setting.
            </Text>
            <HStack>
              <Button height={8} px={10} onClick={closeModal}>
                Got it!
              </Button>
            </HStack>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default memo(LockConversationGeneralInfoModal);
